var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_72139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6014 5.15459C19.4883 4.7291 19.2654 4.34077 18.9551 4.02847C18.6448 3.71617 18.2579 3.49084 17.8332 3.37504C16.2695 2.95459 10.0195 2.95459 10.0195 2.95459C10.0195 2.95459 3.76953 2.95459 2.20589 3.37504C1.78114 3.49084 1.39425 3.71617 1.08394 4.02847C0.773628 4.34077 0.550786 4.7291 0.437713 5.15459C0.0195313 6.72504 0.0195312 10 0.0195312 10C0.0195312 10 0.0195313 13.275 0.437713 14.8455C0.550786 15.271 0.773628 15.6593 1.08394 15.9716C1.39425 16.2839 1.78114 16.5092 2.20589 16.625C3.76953 17.0455 10.0195 17.0455 10.0195 17.0455C10.0195 17.0455 16.2695 17.0455 17.8332 16.625C18.2579 16.5092 18.6448 16.2839 18.9551 15.9716C19.2654 15.6593 19.4883 15.271 19.6014 14.8455C20.0195 13.275 20.0195 10 20.0195 10C20.0195 10 20.0195 6.72504 19.6014 5.15459Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97461 12.9739V7.02612L13.2019 9.99999L7.97461 12.9739Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_72139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.947f5df79f17495697b8b83f1b2c42d5.svg";
export { ForwardRef as ReactComponent };